/* eslint no-shadow: 0 */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'underscore';
import { withTranslation } from 'react-i18next';
import { titleize, unescapeHTML } from 'underscore.string';
import AuditHistory from 'components/modules/shipments/AuditHistory';
import DataPoller from 'components/ui/DataPoller';
import CustomerStore from 'stores/CustomerSearchStore';
import CustomerActionCreators from 'actions/CustomersActionCreators';
import LabelValue from 'components/ui/tailwind/label-value';
import AccountContacts from 'components/v2/contacts';
import RecentActivity from 'components/modules/user/recent-activity';
import CargomaticCard from 'components/v2/card';
import CargomaticModal from 'components/v2/modal';
import CargomaticInput from 'components/v2/input';
import CargomaticSelect from 'components/v2/select';
import { stateCodes } from 'components/modules/user/user-form-utils';
import { getAddressString, hasAddress, } from 'utils/transformers/AddressTransformer';
import DriverDocuments from './DriverDocuments';
import Capability from '../Capability';
import EditButton from '../../../v2/buttons/EditButton';
import Badge from '../../../v2/Badge';
import { Avatar } from '../Avatar';
const POLLING_FREQ = 10000;
const REQUIRED_ATTRIBUTES = [
    'first_name',
    'last_name',
    'username',
    'phone',
    'email',
    'street',
    'city',
    'state',
    'zipcode',
];
const getRequiredAsterisk = (field) => {
    return REQUIRED_ATTRIBUTES.includes(field) ? '*' : '';
};
class DriverDetails extends Component {
    constructor(props) {
        super(props);
        this.isRequiredField = () => `${this.props.t('IS_REQUIRED_FIELD')}`;
        this.onAuditChange = () => {
            const audits = CustomerStore.getCustomerAudits();
            if (!_.isEqual(audits, this.state.audits)) {
                return this.setState({ audits });
            }
        };
        this.onCarrierProfileRedirect = () => {
            const { driver } = this.state;
            const carrierId = driver.carrier._id || driver.carrier;
            window.location.href = `/users/${carrierId}`;
        };
        this.onSave = () => {
            const { changed, driver } = this.state;
            if (this.state.category === 'address') {
                if (!this.areRequiredFieldsPresent(driver.address, [
                    'street',
                    'street2',
                    'city',
                    'state',
                    'zipcode',
                ])) {
                    return;
                }
            }
            // @TODO maybe refactor this...
            _.map(changed, (item, key) => {
                if (!['badges', 'address', 'test'].includes(key)) {
                    if (driver[key] && driver[key] instanceof String) {
                        driver[key] = driver[key].trim();
                    }
                }
                if (key === 'address') {
                    const address = driver.address;
                    _.map(driver.address, (item, key) => {
                        address[key] = address[key].trim();
                    });
                    driver.address = address;
                }
            });
            const updates = _.pick(driver, Object.keys(changed));
            updates._id = driver._id; // Didn't change but needed for the PATCH
            this.props.onSaveDetails('Driver', updates);
        };
        this.getUserAudits = () => {
            CustomerActionCreators.fetchCustomerAudits(this.props.details._id);
        };
        this.areRequiredFieldsPresent = (parent, fields) => {
            const { t } = this.props;
            let errors;
            this.setState((prevState) => {
                errors = prevState.errors;
                fields.forEach((field) => {
                    errors[field] =
                        !parent[field] && REQUIRED_ATTRIBUTES.includes(field)
                            ? {
                                message: `${t(field.toUpperCase())} ${this.isRequiredField()}`,
                            }
                            : {};
                });
                return Object.assign(Object.assign({}, prevState), { errors });
            });
            const allPresent = _.every(fields, (f) => _.isEmpty(errors[f]));
            return allPresent;
        };
        this.handleAddressFieldChange = (field, value) => {
            const { t } = this.props;
            const { driver, changed, errors } = this.state;
            const address = driver.address;
            address[field] = value;
            driver.address = address;
            changed.address = true;
            errors[field] =
                !value && REQUIRED_ATTRIBUTES.includes(field)
                    ? {
                        message: `${t(field.toUpperCase())} ${this.isRequiredField()}`,
                    }
                    : {};
            this.setState({ driver, changed, errors });
        };
        this.handleBadgeFieldChange = (field, value) => {
            const { t } = this.props;
            const { driver, changed, errors } = this.state;
            let badges = driver.badges || [];
            if (value === false) {
                badges = badges.filter((badge) => {
                    return badge.type !== field;
                });
            }
            else if (!_.findWhere(badges, { type: field })) {
                badges.push({ type: field });
            }
            driver.badges = badges;
            changed.badges = true;
            errors[field] =
                !value && REQUIRED_ATTRIBUTES.includes(field)
                    ? {
                        message: `${t(field.toUpperCase())} ${this.isRequiredField()}`,
                    }
                    : {};
            this.setState({ driver, changed, errors });
        };
        this.handleFieldChange = (field, value) => {
            const { t } = this.props;
            const { driver, changed, errors } = this.state;
            driver[field] = value;
            changed[field] = true;
            errors[field] =
                !value && REQUIRED_ATTRIBUTES.includes(field)
                    ? {
                        message: `${t(field.toUpperCase())} ${this.isRequiredField()}`,
                    }
                    : {};
            this.setState({ driver, changed, errors });
        };
        this.renderAccountModal = () => {
            const { errors, driver } = this.state;
            const { first_name, last_name, username, cdl, phone, email, authorized, test, address: { street, street2, city, state, zipcode }, badges, } = driver;
            const tsa = _.findWhere(badges, { type: 'tsa' }) != null;
            const residential = _.findWhere(badges, { type: 'residential' }) != null;
            const { category } = this.state;
            const { t } = this.props;
            return (React.createElement("div", null,
                category === 'account' && (React.createElement("div", { className: "grid sm:grid-cols-6 sm:gap-4 gap-y-6" },
                    React.createElement(CargomaticInput, { className: "sm:col-span-3", error: errors.first_name, label: `${t('FIRST_NAME')} ${getRequiredAsterisk('first_name')}`, info: t('DRIVERS_FIRST_NAME'), onChange: (value) => this.handleFieldChange('first_name', value), value: first_name }),
                    React.createElement(CargomaticInput, { className: "sm:col-span-3", error: errors.last_name, label: `${t('LAST_NAME')} ${getRequiredAsterisk('last_name')}`, info: t('DRIVERS_LAST_NAME'), onChange: (value) => this.handleFieldChange('last_name', value), value: last_name }),
                    React.createElement(CargomaticInput, { className: "sm:col-span-3", error: errors.phone, label: `${t('PHONE_NUMBER')} ${getRequiredAsterisk('phone')}`, info: t('DRIVERS_PHONE_NUMBER'), onChange: (value) => this.handleFieldChange('phone', value), value: phone }),
                    React.createElement(CargomaticInput, { className: "sm:col-span-3", error: errors.username, label: `${t('USERNAME')} ${getRequiredAsterisk('username')}`, info: t('DRIVER_USERNAME'), onChange: (value) => this.handleFieldChange('username', value), value: username }),
                    React.createElement(CargomaticInput, { className: "sm:col-span-4", error: errors.email, label: `${t('EMAIL_ADDRESS')} ${getRequiredAsterisk('email')}`, info: t('DRIVER_EMAIL_ADDRESS'), onChange: (value) => this.handleFieldChange('email', value), value: email, maxLength: 254 }),
                    React.createElement(CargomaticInput, { className: "sm:col-span-3", error: errors.cdl, label: `${t('COMMERCIAL_DRIVERS_LICENSE')} ${getRequiredAsterisk('cdl')}`, info: t('COMMERCIAL_DRIVER_LICENSE_TIP'), onChange: (value) => this.handleFieldChange('cdl', value), value: cdl }))),
                category === 'address' && (React.createElement("div", null,
                    React.createElement("h3", { className: "mt-0 mb-4" }, t('ACCOUNT_INFORMATION')),
                    React.createElement("div", { className: "grid sm:grid-cols-3 sm:gap-4 gap-y-6" },
                        React.createElement(CargomaticInput, { className: "sm:col-span-full", error: errors.street, label: `${titleize(t('STREET'))} ${getRequiredAsterisk('street')}`, info: t('DRIVER_STREET'), onChange: (value) => {
                                this.handleAddressFieldChange('street', value);
                            }, value: street }),
                        React.createElement(CargomaticInput, { className: "sm:col-span-full", error: errors.street2, label: `${titleize(t('STREET_2'))} ${getRequiredAsterisk('street2')}`, info: t('DRIVER_STREET_2'), onChange: (value) => {
                                this.handleAddressFieldChange('street2', value);
                            }, value: street2 }),
                        React.createElement(CargomaticInput, { error: errors.city, label: `${titleize(t('CITY'))} ${getRequiredAsterisk('city')}`, info: t('DRIVER_CITY'), onChange: (value) => {
                                this.handleAddressFieldChange('city', value);
                            }, value: city }),
                        React.createElement(CargomaticSelect, { error: errors.state, selected: state, info: t('DRIVER_STATE'), items: stateCodes, label: `${titleize(t('STATE'))} ${getRequiredAsterisk('state')}`, valueKey: "abbreviation", textKey: "name", onSelect: (item) => {
                                this.handleAddressFieldChange('state', item.abbreviation);
                            } }),
                        React.createElement(CargomaticInput, { error: errors.zipcode, label: `${t('ZIP_CODE')} ${getRequiredAsterisk('zipcode')}`, info: t('DRIVER_POSTAL_CODE'), onChange: (value) => {
                                this.handleAddressFieldChange('zipcode', value);
                            }, value: zipcode })))),
                category === 'capabilities' && (React.createElement("div", null,
                    React.createElement("h3", { className: "mt-0 mb-4" }, t('CAPABILITIES')),
                    React.createElement("div", { className: "grid sm:grid-cols-2 sm:gap-x-4 gap-y-2" },
                        React.createElement(CargomaticInput, { id: "authorized", type: "checkbox", error: errors.authorized, label: `${titleize(t('AUTHORIZED'))} ${getRequiredAsterisk('authorized')}`, info: t('DRIVER_AUTHORIZATION_STATUS'), onChange: (value) => {
                                this.handleFieldChange('authorized', value);
                            }, value: authorized }),
                        React.createElement(CargomaticInput, { id: "tsa", type: "checkbox", error: errors.tsa, label: `${t('TSA')} ${getRequiredAsterisk('tsa')}`, info: t('DRIVER_TSA_CERTIFICATION_STATUS'), onChange: (value) => this.handleBadgeFieldChange('tsa', value), value: tsa }),
                        React.createElement(CargomaticInput, { id: "residential", type: "checkbox", error: errors.residential, label: `${t('RESIDENTIAL')} ${getRequiredAsterisk('residential')}`, info: t('DRIVER_RESIDENTIAL_STATUS'), onChange: (value) => {
                                this.handleBadgeFieldChange('residential', value);
                            }, value: residential }),
                        React.createElement(CargomaticInput, { id: "test", type: "checkbox", error: errors.test, label: `${t('TEST_USER')} ${getRequiredAsterisk('test')}`, info: t('DRIVER_TEST_USER_STATUS'), onChange: (value) => this.handleFieldChange('test', value), value: test })))),
                React.createElement("div", { className: "mt-4 form-actions" },
                    React.createElement("button", { className: "button button-green", onClick: this.onSave, disabled: this.errorsExist() }, t('SAVE')))));
        };
        this.state = {
            showAccountModal: false,
            category: null,
            driver: props.details,
            audits: [],
            errors: {
                first_name: {},
                last_name: {},
                username: {},
                cdl: {},
                phone: {},
                email: {},
                address: {},
                authorized: {},
                tsa: {},
                residential: {},
                test: {},
            },
            changed: {},
        };
    }
    componentDidMount() {
        CustomerStore.addAuditChangeListener(this.onAuditChange);
    }
    componentWillUnmount() {
        CustomerStore.removeAuditChangeListener(this.onAuditChange);
    }
    errorsExist() {
        const { errors } = this.state;
        let errorsExist = false;
        _.map(errors, (value, key) => {
            if (!_.isEmpty(errors[key]))
                errorsExist = true;
        });
        return errorsExist;
    }
    renderAddress() {
        const { driver: { address }, } = this.state;
        const addressString = getAddressString(address);
        return React.createElement(LabelValue, { value: addressString, icon: "map-marker" });
    }
    render() {
        const { driver } = this.state;
        const { badges, authorized, carrier } = driver;
        const { t } = this.props;
        const tsa = _.findWhere(badges, { type: 'tsa' }) != null;
        const residential = _.findWhere(badges, { type: 'residential' }) != null;
        return (React.createElement("div", { className: "mx-auto my-16 max-w-screen-2xl md:my-32 lg:my-16" },
            React.createElement(DataPoller, { action: this.getUserAudits, frequency: POLLING_FREQ }),
            React.createElement("div", { className: "lg:grid lg:grid-cols-4 lg:gap-6" },
                React.createElement("div", { className: "col-span-1" },
                    React.createElement(CargomaticCard, { className: "mb-6" },
                        React.createElement("div", { className: "text-center" },
                            React.createElement("div", { className: "flex justify-center py-6" },
                                React.createElement(Avatar, { key: driver._id, userId: driver._id, className: "h-32 w-32 cursor-pointer rounded-full" })),
                            React.createElement("div", { className: "flex flex-wrap justify-center items-center gap-x-2 gap-y-2 " },
                                React.createElement(Badge, { color: "blue" }, t('DRIVER')),
                                authorized ? (React.createElement(Badge, { color: "green" }, t('DRIVER_AUTHORIZED'))) : (React.createElement(Badge, { color: "red" }, t('DRIVER_UNAUTHORIZED'))),
                                carrier.authorized ? (React.createElement(Badge, { color: "green" }, t('CARRIER_AUTHORIZED'))) : (React.createElement(Badge, { color: "red" }, t('CARRIER_UNAUTHORIZED')))),
                            React.createElement("h2", { className: "text-grey-darker" }, `${driver.first_name} ${driver.last_name}`),
                            React.createElement("a", { className: "cursor-pointer text-grey-darker", onClick: this.onCarrierProfileRedirect }, driver.carrier && unescapeHTML(driver.carrier.name)),
                            React.createElement("button", { className: "button button-secondary text-grey-darker", onClick: this.props.onOpenJobs }, t('VIEW_JOBS')))),
                    React.createElement(CargomaticCard, { className: "mb-6", header: () => (React.createElement("header", { onClick: () => {
                                this.setState({
                                    category: 'account',
                                    showAccountModal: true,
                                });
                            }, className: "flex items-center justify-between" },
                            React.createElement("h3", { className: "my-0" }, t('ACCOUNT_DETAILS')),
                            React.createElement(EditButton, null))) },
                        React.createElement(LabelValue, { value: `${driver.first_name} ${driver.last_name}`, icon: "user" }),
                        React.createElement(LabelValue, { value: driver.username, icon: "lock" }),
                        React.createElement(LabelValue, { value: driver.phone, icon: "phone" }),
                        React.createElement(LabelValue, { value: driver.cdl, icon: "envelope" })),
                    React.createElement("div", { className: "mt-6" },
                        React.createElement("button", { className: "w-full button button-hollow-red", onClick: this.props.onChangePasswordClick }, t('CHANGE_PASSWORD')))),
                React.createElement("div", { className: "col-span-2" },
                    React.createElement("div", { className: "mb-6" },
                        React.createElement(RecentActivity, { email: driver.email })),
                    React.createElement(CargomaticCard, { className: "mb-6", header: () => React.createElement("h3", { className: "my-0" }, t('DOCUMENTS')) },
                        React.createElement(DriverDocuments, { id: driver._id })),
                    React.createElement(CargomaticCard, { className: "mb-6", header: () => React.createElement("h3", { className: "my-0" }, t('AUDIT_HISTORY')) },
                        React.createElement(AuditHistory, { audits: this.state.audits, paginate: true })),
                    React.createElement(CargomaticCard, null,
                        React.createElement(AccountContacts, { contacts: driver.contacts, userId: driver._id }))),
                React.createElement("div", { className: "col-span-1" },
                    React.createElement(CargomaticCard, { className: "mb-6", header: () => (React.createElement("header", { onClick: () => {
                                this.setState({
                                    category: 'address',
                                    showAccountModal: true,
                                });
                            } },
                            React.createElement("div", { className: "flex items-center justify-between" },
                                React.createElement("h3", { className: "my-0" }, t('ADDRESS_DETAILS')),
                                React.createElement(EditButton, null)))) },
                        hasAddress(driver.address) && this.renderAddress(driver.address),
                        !hasAddress(driver.address) && (React.createElement(LabelValue, { value: t('NO_ADDRESS_ON_FILE'), icon: "map-marker" }))),
                    React.createElement(CargomaticCard, { className: "mb-6", header: () => (React.createElement("header", { onClick: () => {
                                this.setState({
                                    category: 'capabilities',
                                    showAccountModal: true,
                                });
                            } },
                            React.createElement("div", { className: "flex items-center justify-between" },
                                React.createElement("h3", { className: "my-0" }, t('CAPABILITIES')),
                                React.createElement(EditButton, null)))) },
                        React.createElement(Capability, { label: titleize(t('AUTHORIZED')), checked: driver.authorized }),
                        React.createElement(Capability, { label: t('TSA'), checked: tsa }),
                        React.createElement(Capability, { label: t('RESIDENTIAL'), checked: residential }),
                        React.createElement(Capability, { label: t('TEST'), checked: residential })))),
            this.state.showAccountModal && (React.createElement(CargomaticModal, { show: true, onHide: () => this.setState({ showAccountModal: false }), title: t('ACCOUNT_INFORMATION'), body: this.renderAccountModal(), footer: null, location: "middle" }))));
    }
}
DriverDetails.propTypes = {
    details: PropTypes.object,
    // onAuthorize: PropTypes.func,
    onOpenJobs: PropTypes.func.isRequired,
    // onOpenPassword: PropTypes.func.isRequired,
    onSaveDetails: PropTypes.func.isRequired,
};
export default withTranslation()(DriverDetails);
